var _rect, _rect2, _circle, _path, _path2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultBenefit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    rx: 32,
    fill: "#F4F6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 1080,
    height: 680,
    rx: 28,
    fill: "#E9EEF2",
    stroke: "#D3DCE5",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 300,
    r: 92,
    fill: "#FFB902"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 246C564.654 246 536 274.654 536 310V318H664V310C664 274.654 635.346 246 600 246Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470 500C470 438.144 520.144 388 582 388H618C679.856 388 730 438.144 730 500V514H470V500Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 586,
    width: 380,
    height: 24,
    rx: 12,
    fill: "#C5D0DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 634,
    width: 260,
    height: 20,
    rx: 10,
    fill: "#D3DCE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBenefit);
export default __webpack_public_path__ + "static/media/default-benefit.597679b31249415f4eaa15a99f08e7f6.svg";
export { ForwardRef as ReactComponent };